import type { RouteObject } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { ADMINISTRATOR } from '@/shared/guards/roles';
import { NotifyEmailsPage } from './pages/NotifyEmailsPage';

export const notifyRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={[ADMINISTRATOR]} />,
    children: [{ path: 'notify/emails', element: <NotifyEmailsPage /> }],
  },
];
